import { UserProfile } from '@/components/common/navigation/sidebar/components/user-profile';
import Button from '@/components/global/button';
import Typography from '@/components/global/typography';
import { useUser } from '@/lib/hooks';
import { cn } from '@/lib/utils';
import { useI18n } from '@/locales/client';
import { ChevronLeft, SquareUserRound } from 'lucide-react';
import Link from 'next/link';
import { memo } from 'react';

const MemoizedUserProfile = memo(UserProfile);

function ProfileSidebar() {
  const t = useI18n();
  const { isLawyer } = useUser();

  const settings = [
    {
      id: 1,
      name: t('dashboard.profile.personalInformation'),
      icon: <SquareUserRound />,
      isActive: true,
    },
    // {
    //   id: 2,
    //   name: t('dashboard.profile.contactInformation'),
    //   icon: <Phone />,
    //   isActive: false,
    // },
    // {
    //   id: 3,
    //   name: t('dashboard.profile.paymentMethods'),
    //   icon: <Wallet />,
    //   isActive: false,
    // },
    // {
    //   id: 4,
    //   name: t('dashboard.profile.paymentHistory'),
    //   icon: <History />,
    //   isActive: false,
    // },
  ];

  return (
    <div
      className={cn(
        'border-gray-[#E5E7EB] flex h-[calc(100vh-72px)] w-full flex-col border-r bg-white dark:border-gray-700 dark:bg-gray-900'
      )}
    >
      <div className='flex h-full flex-col'>
        <div className='flex-1 overflow-y-auto p-6'>
          <div className='flex flex-col gap-6'>
            {isLawyer && (
              <Link href='/dashboard' className='w-full'>
                <Button variant='neutral' size='sm' className='w-full gap-2'>
                  <Typography
                    size='p'
                    weight='bold'
                    className='flex items-center justify-center gap-1'
                  >
                    <ChevronLeft /> {t('dashboard.profile.back')}
                  </Typography>
                </Button>
              </Link>
            )}

            <Typography size='p' weight='bold'>
              {t('dashboard.profile.accountSettings')}
            </Typography>

            <div className='flex flex-col gap-4'>
              {settings.map((setting) => (
                <Button
                  variant='ghost'
                  size='lg'
                  className='justify-start gap-2'
                  key={setting.id}
                  isActive={setting.isActive}
                >
                  {setting.icon} {setting.name}
                </Button>
              ))}
            </div>
          </div>
        </div>

        <div className='shrink-0 border-t border-gray-200 p-6 dark:border-gray-700'>
          <MemoizedUserProfile />
        </div>
      </div>
    </div>
  );
}

export default memo(ProfileSidebar);
